<div class="container py-4">
  <h2>{{ 'ADMIN.USERS.TITLE' | translate }}</h2>

  <div class="row g-2 mt-2 align-items-end">
    <div class="col-md-2">
      <app-enum-select
        [formGroup]="filterForm"
        controlName="roleFilter"
        [enum]="roleFilterOptions"
        [label]="'ADMIN.USERS.FILTER_ROLE'"
        [castFunction]="roleFilterLabelKey"
      />
    </div>
    <div class="col-md-2">
      <app-enum-select
        [formGroup]="filterForm"
        controlName="activeFilter"
        [enum]="activeFilterOptions"
        [label]="'ADMIN.USERS.FILTER_ACTIVE'"
        [castFunction]="activeFilterLabelKey"
      />
    </div>
    <div class="col-md-3">
      <app-text-search
        [value]="searchTerm"
        (valueChange)="searchTerm = $event ?? ''"
        [labelKey]="'ADMIN.USERS.FILTER_SEARCH_LABEL'"
        [placeholderKey]="'ADMIN.USERS.FILTER_SEARCH_PLACEHOLDER'"
        [showClearButton]="true"
        inputId="admin-users-search"
        [disabled]="listLoading"
      />
    </div>
    <div class="col-md-2">
      <label class="form-label mb-0 small">&nbsp;</label>
      <app-mdb-button
        [text]="'ADMIN.APPLY'"
        color="primary"
        [outlined]="true"
        customClasses="w-100 d-block"
        [disabled]="listLoading"
        (onClick)="applyFilters()"
      />
    </div>
    <div class="col-md-3 d-flex justify-content-end gap-2 align-items-end">
      <app-mdb-button
        [text]="'ADMIN.USERS.ADD_BUTTON'"
        color="primary"
        [disabled]="listLoading"
        (onClick)="openCreateModal()"
      />
    </div>
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger mt-2 mb-0" role="alert">{{ errorMessage | translate }}</div>
  }

  <div class="table-responsive mt-4">
    <table class="table table-sm">
      <thead>
        <tr>
          <th scope="col">{{ 'USERNAME' | translate }}</th>
          <th scope="col">{{ 'EMAIL' | translate }}</th>
          <th scope="col">{{ 'ROLE' | translate }}</th>
          <th scope="col">{{ 'ADMIN.USERS.ACTIVE' | translate }}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        @if (listLoading) {
          <tr>
            <td colspan="5" class="text-center py-4">
              <app-spinner></app-spinner>
              <span class="ms-2">{{ 'LOADING_RESULTS' | translate }}</span>
            </td>
          </tr>
        } @else if (users.length === 0) {
          <tr>
            <td colspan="5" class="text-center text-muted py-4">{{ 'NO_RESULTS_FOUND' | translate }}</td>
          </tr>
        } @else {
          @for (user of users; track user.id) {
            <tr>
              <td>{{ user.username }}</td>
              <td>{{ user.email ?? '-' }}</td>
              <td>{{ (user.role === 'admin' ? 'ENUMS.ROLE.ADMIN' : 'ENUMS.ROLE.USER') | translate }}</td>
              <td>
                <div class="form-check">
                  <input
                    mdbCheckbox
                    class="form-check-input"
                    type="checkbox"
                    [checked]="user.active"
                    [disabled]="true"
                  />
                </div>
              </td>
              <td>
                <div class="d-flex gap-2">
                  <app-mdb-button
                    [text]="'EDIT'"
                    color="primary"
                    [outlined]="true"
                    size="sm"
                    (onClick)="openEditModal(user)"
                  />
                  <app-mdb-button
                    [text]="user.active ? 'ADMIN.USERS.DEACTIVATE' : 'ADMIN.USERS.ACTIVATE'"
                    color="secondary"
                    [outlined]="true"
                    size="sm"
                    customClasses="toggle-active-btn"
                    [loading]="togglingUserId === user.id"
                    [disabled]="loading || deletingUserId !== null"
                    (onClick)="toggleActive(user)"
                  />
                  <app-mdb-button
                    [text]="'DELETE'"
                    color="danger"
                    [outlined]="true"
                    size="sm"
                    [loading]="deletingUserId === user.id"
                    [disabled]="deletingUserId !== null"
                    (onClick)="openDeleteConfirmModal(user)"
                  />
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <app-list-pagination-bar
    [meta]="paginationMeta"
    [perPageOptions]="perPageOptions"
    [loading]="listLoading"
    selectId="per-page-users"
    (perPageChange)="onPerPageChange($event)"
    (previousClicked)="previousPage()"
    (nextClicked)="nextPage()"
  />
</div>
